/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CorrespondenceGoTarget } from '../models/correspondenceGoTarget';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListBillsApiV1MyCorrespondenceBillsGetParams } from '../models/listBillsApiV1MyCorrespondenceBillsGetParams';

import type { ListTicketsApiV1MyCorrespondenceTicketsGetParams } from '../models/listTicketsApiV1MyCorrespondenceTicketsGetParams';

import type { MyCorrespondenceBillDetail } from '../models/myCorrespondenceBillDetail';

import type { MyCorrespondenceBillPage } from '../models/myCorrespondenceBillPage';

import type { MyCorrespondencePublicMessage } from '../models/myCorrespondencePublicMessage';

import type { MyCorrespondenceReplyCreate } from '../models/myCorrespondenceReplyCreate';

import type { MyCorrespondenceSummary } from '../models/myCorrespondenceSummary';

import type { MyCorrespondenceTicketDetail } from '../models/myCorrespondenceTicketDetail';

import type { MyCorrespondenceTicketPage } from '../models/myCorrespondenceTicketPage';

import type { ResolveGoApiV1MyCorrespondenceGoGetParams } from '../models/resolveGoApiV1MyCorrespondenceGoGetParams';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Counts that gate the user-menu entry (id-only discovery, no envelope read).
 * @summary Get Summary
 */
export const getSummaryApiV1MyCorrespondenceSummaryGet = (
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondenceSummary>({
    url: `/api/v1/my-correspondence/summary`,
    method: 'GET',
    signal
  });
};

export const getGetSummaryApiV1MyCorrespondenceSummaryGetQueryKey = () => {
  return [`/api/v1/my-correspondence/summary`] as const;
};

export const getGetSummaryApiV1MyCorrespondenceSummaryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSummaryApiV1MyCorrespondenceSummaryGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>
  > = ({ signal }) => getSummaryApiV1MyCorrespondenceSummaryGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSummaryApiV1MyCorrespondenceSummaryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>
>;
export type GetSummaryApiV1MyCorrespondenceSummaryGetQueryError = unknown;

export function useGetSummaryApiV1MyCorrespondenceSummaryGet<
  TData = Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSummaryApiV1MyCorrespondenceSummaryGet<
  TData = Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSummaryApiV1MyCorrespondenceSummaryGet<
  TData = Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Summary
 */

export function useGetSummaryApiV1MyCorrespondenceSummaryGet<
  TData = Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSummaryApiV1MyCorrespondenceSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSummaryApiV1MyCorrespondenceSummaryGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List a bounded page of cross-tenant support tickets for the verified email.
 * @summary List Tickets
 */
export const listTicketsApiV1MyCorrespondenceTicketsGet = (
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondenceTicketPage>({
    url: `/api/v1/my-correspondence/tickets`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTicketsApiV1MyCorrespondenceTicketsGetQueryKey = (
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams
) => {
  return [
    `/api/v1/my-correspondence/tickets`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListTicketsApiV1MyCorrespondenceTicketsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTicketsApiV1MyCorrespondenceTicketsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>
  > = ({ signal }) =>
    listTicketsApiV1MyCorrespondenceTicketsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTicketsApiV1MyCorrespondenceTicketsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>
>;
export type ListTicketsApiV1MyCorrespondenceTicketsGetQueryError =
  HTTPValidationError;

export function useListTicketsApiV1MyCorrespondenceTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTicketsApiV1MyCorrespondenceTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTicketsApiV1MyCorrespondenceTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tickets
 */

export function useListTicketsApiV1MyCorrespondenceTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1MyCorrespondenceTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1MyCorrespondenceTicketsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTicketsApiV1MyCorrespondenceTicketsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Read-only detail (status, resolution, public thread) of one cross-tenant ticket.
 * @summary Get Ticket
 */
export const getTicketApiV1MyCorrespondenceTicketsTicketIdGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondenceTicketDetail>({
    url: `/api/v1/my-correspondence/tickets/${ticketId}`,
    method: 'GET',
    signal
  });
};

export const getGetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryKey = (
  ticketId?: string
) => {
  return [`/api/v1/my-correspondence/tickets/${ticketId}`] as const;
};

export const getGetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryKey(ticketId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>>
  > = ({ signal }) =>
    getTicketApiV1MyCorrespondenceTicketsTicketIdGet(ticketId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!ticketId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>>
  >;
export type GetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryError =
  HTTPValidationError;

export function useGetTicketApiV1MyCorrespondenceTicketsTicketIdGet<
  TData = Awaited<
    ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketApiV1MyCorrespondenceTicketsTicketIdGet<
  TData = Awaited<
    ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketApiV1MyCorrespondenceTicketsTicketIdGet<
  TData = Awaited<
    ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket
 */

export function useGetTicketApiV1MyCorrespondenceTicketsTicketIdGet<
  TData = Awaited<
    ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTicketApiV1MyCorrespondenceTicketsTicketIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTicketApiV1MyCorrespondenceTicketsTicketIdGetQueryOptions(
      ticketId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Post a public reply to one cross-tenant ticket, the single audited write seam.

The reply is written in the owning tenant's own RLS, email-scoped to the
verified email (``is_sysadmin`` never set), as a public contact message — so
the assigned agent is notified just like a portal/magic-link reply. A ticket
not addressed to the actor returns 404 (a guessed id can never inject a
reply); a closed ticket returns ``TICKET_CLOSED``.
 * @summary Reply To Ticket
 */
export const replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost = (
  ticketId: string,
  myCorrespondenceReplyCreate: MyCorrespondenceReplyCreate,
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondencePublicMessage>({
    url: `/api/v1/my-correspondence/tickets/${ticketId}/messages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: myCorrespondenceReplyCreate,
    signal
  });
};

export const getReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
        >
      >,
      TError,
      { ticketId: string; data: MyCorrespondenceReplyCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
      >
    >,
    TError,
    { ticketId: string; data: MyCorrespondenceReplyCreate },
    TContext
  > => {
    const mutationKey = [
      'replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
        >
      >,
      { ticketId: string; data: MyCorrespondenceReplyCreate }
    > = (props) => {
      const { ticketId, data } = props ?? {};

      return replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost(
        ticketId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
      >
    >
  >;
export type ReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPostMutationBody =
  MyCorrespondenceReplyCreate;
export type ReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPostMutationError =
  HTTPValidationError;

/**
 * @summary Reply To Ticket
 */
export const useReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
          >
        >,
        TError,
        { ticketId: string; data: MyCorrespondenceReplyCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof replyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPost
      >
    >,
    TError,
    { ticketId: string; data: MyCorrespondenceReplyCreate },
    TContext
  > => {
    const mutationOptions =
      getReplyToTicketApiV1MyCorrespondenceTicketsTicketIdMessagesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a bounded page of cross-tenant bills (invoices) for the verified email.
 * @summary List Bills
 */
export const listBillsApiV1MyCorrespondenceBillsGet = (
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondenceBillPage>({
    url: `/api/v1/my-correspondence/bills`,
    method: 'GET',
    params,
    signal
  });
};

export const getListBillsApiV1MyCorrespondenceBillsGetQueryKey = (
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams
) => {
  return [
    `/api/v1/my-correspondence/bills`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListBillsApiV1MyCorrespondenceBillsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBillsApiV1MyCorrespondenceBillsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>
  > = ({ signal }) => listBillsApiV1MyCorrespondenceBillsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBillsApiV1MyCorrespondenceBillsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>
>;
export type ListBillsApiV1MyCorrespondenceBillsGetQueryError =
  HTTPValidationError;

export function useListBillsApiV1MyCorrespondenceBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListBillsApiV1MyCorrespondenceBillsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
          TError,
          Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBillsApiV1MyCorrespondenceBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
          TError,
          Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBillsApiV1MyCorrespondenceBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bills
 */

export function useListBillsApiV1MyCorrespondenceBillsGet<
  TData = Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
  TError = HTTPValidationError
>(
  params?: ListBillsApiV1MyCorrespondenceBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBillsApiV1MyCorrespondenceBillsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListBillsApiV1MyCorrespondenceBillsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Read-only detail (the bill as the customer sees it) of one cross-tenant bill.
 * @summary Get Bill
 */
export const getBillApiV1MyCorrespondenceBillsInvoiceIdGet = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<MyCorrespondenceBillDetail>({
    url: `/api/v1/my-correspondence/bills/${invoiceId}`,
    method: 'GET',
    signal
  });
};

export const getGetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryKey = (
  invoiceId?: string
) => {
  return [`/api/v1/my-correspondence/bills/${invoiceId}`] as const;
};

export const getGetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryKey(invoiceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>>
  > = ({ signal }) =>
    getBillApiV1MyCorrespondenceBillsInvoiceIdGet(invoiceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!invoiceId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>>
  >;
export type GetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryError =
  HTTPValidationError;

export function useGetBillApiV1MyCorrespondenceBillsInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBillApiV1MyCorrespondenceBillsInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBillApiV1MyCorrespondenceBillsInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bill
 */

export function useGetBillApiV1MyCorrespondenceBillsInvoiceIdGet<
  TData = Awaited<
    ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBillApiV1MyCorrespondenceBillsInvoiceIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBillApiV1MyCorrespondenceBillsInvoiceIdGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resolve the home-app bounce target for the /correspondence/go email link.

Returns the logged-in user's home app base URL and the same-origin deep-link
path. The frontend navigates directly when already on the home host, or hops
cross-domain via a one-time code otherwise. Record-level authorization is
enforced when the detail endpoint loads (verified-email-scoped P0 seam), so
this only resolves *where* to send the user, never *whether* they may read it.
 * @summary Resolve Go
 */
export const resolveGoApiV1MyCorrespondenceGoGet = (
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CorrespondenceGoTarget>({
    url: `/api/v1/my-correspondence/go`,
    method: 'GET',
    params,
    signal
  });
};

export const getResolveGoApiV1MyCorrespondenceGoGetQueryKey = (
  params?: ResolveGoApiV1MyCorrespondenceGoGetParams
) => {
  return [`/api/v1/my-correspondence/go`, ...(params ? [params] : [])] as const;
};

export const getResolveGoApiV1MyCorrespondenceGoGetQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
  TError = HTTPValidationError
>(
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getResolveGoApiV1MyCorrespondenceGoGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>
  > = ({ signal }) => resolveGoApiV1MyCorrespondenceGoGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ResolveGoApiV1MyCorrespondenceGoGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>
>;
export type ResolveGoApiV1MyCorrespondenceGoGetQueryError = HTTPValidationError;

export function useResolveGoApiV1MyCorrespondenceGoGet<
  TData = Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
  TError = HTTPValidationError
>(
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
          TError,
          Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useResolveGoApiV1MyCorrespondenceGoGet<
  TData = Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
  TError = HTTPValidationError
>(
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
          TError,
          Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useResolveGoApiV1MyCorrespondenceGoGet<
  TData = Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
  TError = HTTPValidationError
>(
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve Go
 */

export function useResolveGoApiV1MyCorrespondenceGoGet<
  TData = Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
  TError = HTTPValidationError
>(
  params: ResolveGoApiV1MyCorrespondenceGoGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveGoApiV1MyCorrespondenceGoGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getResolveGoApiV1MyCorrespondenceGoGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
